import React, {forwardRef, useImperativeHandle, useRef, useState, useEffect} from "react";
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { useTranslation } from "react-i18next";

export default forwardRef((props:IFilterParams, ref) => {
    let checkObj:any = {};
    const [optionsState, setOptionsState] = useState([<option key="nie"></option>]);
    const {t} = useTranslation();
    const updateValues = () => {
        let options:JSX.Element[] = [];
        props.rowModel.forEachNode((rowNode:any) => {
            var valueAvailable = props.doesRowPassOtherFilter(rowNode);
            let value;
            try {
                const item = JSON.parse(props.valueGetter(rowNode));
                if(typeof item !== 'number'){
                    value = item.medium
                }
                else {
                    value = item;
                }
            } catch (error) {
                value = props.valueGetter(rowNode)
            }
            if(value !== undefined && value !== null){
                if( checkObj[value] === undefined){
                    checkObj[value] = [];
                }
                checkObj[value].push(valueAvailable);
            }
        });

        const ordered:{[key:string]:{}} = {};
        Object.keys(checkObj).sort(sortAlphaNum).forEach(function(key) {
        ordered[key] = checkObj[key];
        });

        Object.keys(ordered).forEach(key => {
            let values = checkObj[key];
            let optionDisabaled = false;
            if(values.indexOf(true) === -1){
                // Ändern auf True wenn funktionieren soll
                optionDisabaled = true;
            };
        options.push(<option disabled={optionDisabaled} key={key}>{key} {optionDisabaled ? t('table.select.noResults') : null}</option>)
        });
        setOptionsState(options)
    }
useEffect(()=>{ 
    updateValues();
},[])

    const inputRef = useRef<HTMLSelectElement>(null);
    useImperativeHandle(ref, () => {
        return {
            isFilterActive() {
                return inputRef.current!.value !== '';
            },
            onNewRowsLoaded: () => {
               updateValues()
            },
            doesFilterPass: (params:IDoesFilterPassParams) => {
                const colName = props.column.getColDef().field as string;
                if(params.data[colName] !== undefined){
                    if(params.data[colName] !== null){
                        return params.data[colName].indexOf(inputRef.current!.value.toString()) !== -1;
                    }
                    
                }
                else {
                    return false;
                }
            },
            setModel: (params:any) => {
                console.log('test', params)
            }
        };
    });
    return (
        <select ref={inputRef} onChange={() => props.filterChangedCallback()} className="gemu-rs-filter-select-box">
            <option key="null"></option>
            {optionsState} 
        </select>
    );
})

const sortAlphaNum = (a:any, b:string|number) => {return a.localeCompare(b, 'de', { numeric: true })};